import React from 'react';

import GradeBlocks from './grade_blocks';

export default function GradeBlocksSetup({ isLoading, subscreenRestricted, subscreenLocked, subscreen, schoolInfo, scheduleInfo, setScheduleInfo, periods = [], setPeriods = ()=>{}, periodsLoading = false, teachers = [], students = [], courses = [], setCourses = ()=>{}, classrooms = [], blocks = [], setBlocks = ()=>{}, homeroomGradeGroups = null, homeroomGradeGroupsLoading = false, handleMoveToNextScreen }) {
	return (
		<div>
			{isLoading ? (
				<div className='center-text'>
					<img src={require('../../../images/balls.gif')} alt='Loading...' style={{height:'40px'}}/>
				</div>
			) : (
				<>
					{(() => {
						switch(subscreen) {
							case 'grade_blocks':
								return <GradeBlocks subscreenRestricted={subscreenRestricted} subscreenLocked={subscreenLocked} schoolInfo={schoolInfo} scheduleInfo={scheduleInfo} setScheduleInfo={setScheduleInfo} periods={periods} setPeriods={setPeriods} periodsLoading={periodsLoading} teachers={teachers} students={students} courses={courses} setCourses={setCourses} classrooms={classrooms} blocks={blocks} setBlocks={setBlocks} initialHomeroomGroups={homeroomGradeGroups} initialHomeroomGroupsLoading={homeroomGradeGroupsLoading} handleMoveToNextScreen={handleMoveToNextScreen}/>;
							default:
								return null;
						}
					})()}
				</>
			)}
		</div>
	);
}
